//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

function UnlockShiptoManagement() {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/unlock-shipto-management?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function searchAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/unlock-shipto-management/search?query=${query}`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function Export(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/unlock-shipto-management/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
 async function updateShiptoStatus(values) {
     try {
       const obj = {
         method: "PUT",
         credentials: 'include',
         headers: {
           "Content-Type": "application/json"          
         },
         body: JSON.stringify(values),
       };
       let res = await fetch(`${config.host}/cdr-panel/unlock-shipto-management`, obj);
       return handleResponse(res);
     } 
     catch (err) {
       handleError(err);
     }
   }
    async function createShipto(values) {
       try {
         const obj = {
           method: "POST",
           credentials: 'include',
           headers: {
             "Content-Type": "application/json"          
           },
           body: JSON.stringify(values),
         };
         let res = await fetch(`${config.host}/cdr-panel/unlock-shipto-management/create`, obj);
         return handleResponse(res);
       } catch (err) {
         handleError(err);
       }
     }
      async function saveShiptoEligibility(values) {
       try {
         const obj = {
           method: "POST",
           credentials: 'include',
           headers: {
             "Content-Type": "application/json"          
           },
           body: JSON.stringify(values),
         };
         let res = await fetch(`${config.host}/cdr-panel/unlock-shipto-management/save`, obj);
         return handleResponse(res);
       } catch (err) {
         handleError(err);
       }
     }
    async function uploadUnlockShipto(values) {
        try {
          const obj = {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json"          
            },
            body: JSON.stringify(values),
          };
          let res = await fetch(`${config.host}/cdr-panel/unlock-shipto-management/uploadUnlockShipto`, obj);
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      
        async function filter(values) {
          try {
            const obj = {
              method: "GET",
              credentials: 'include',
              headers: {
                "Content-Type": "application/json"
              },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
              `${config.host}/cdr-panel/unlock-shipto-management/filter?query=${query}`,
              obj
            );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }
    
  return {
    getAPI,
    searchAPI,
    Export,
    filter,
    updateShiptoStatus,
    createShipto,
    uploadUnlockShipto,
    saveShiptoEligibility
  };

}

export default UnlockShiptoManagement;
